import { z } from 'zod';

import { GlobalResponseSchema } from './global-schema';

export const UserProfileEditBodySchema = z.object({
  firstname: z.string(),
  lastname: z.string(),
  //   email: z.string(),
});

export const UserSchema = z.object({
  firstname: z.string().nullable(),
  lastname: z.string().nullable(),
  type: z.number(),
  /** When set (e.g. from API), may mirror role; also see `current_type_name`. */
  type_name: z.string().optional(),
  current_type_name: z.string(),
  current_carrier: z
    .object({
      id: z.number(),
      type: z.number(),
      name: z.string(),
      is_check_lock_trucks: z.boolean(),
      is_self_carrier: z.boolean(),
    })
    .nullable(),
  current_group_name: z.string().nullable(),
  default_length: z.string(),
  default_size: z.string(),
  current_plan: z
    .object({
      expired: z.string(),
      id: z.number(),
      title: z.string(),
      icon: z.string(),
      is_trial: z.boolean(),
      accessibilities: z
        .array(
          z.object({
            id: z.number(),
            title: z.string(),
            value: z.number(),
            remain_value: z.number(),
            created: z.string(),
          }),
        )
        .nullable(),
    })
    .nullish(),
});

export const BrokerSchema = z.object({
  id: z.number(),
  title: z.string(),
  manager: z.string(),
  lat: z.number(),
  lng: z.number(),
});

export const CarrierSchema = z.object({
  id: z.number(),
  title: z.string(),
  manager: z.string(),
  lat: z.number(),
  lng: z.number(),
});

export const UserGroupsSchema = z.object({
  id: z.number(),
  type: z.string(),
  name: z.string(),
  broker: z
    .object({
      id: z.number(),
      manager: z.string(),
      lat: z.number().nullable(),
      lng: z.number().nullable(),
    })
    .nullable(),
  carrier: z
    .object({
      id: z.number(),
      title: z.string(),
      manager: z.string(),
      lat: z.number().nullable(),
      lng: z.number().nullable(),
    })
    .nullable(),
});

export const UserResponseSchema = GlobalResponseSchema.extend({
  data: UserSchema,
});

export const UserGroupResponseSchema = GlobalResponseSchema.extend({
  data: z.array(UserGroupsSchema),
});
